import { URLGenerater } from "../../Pages/CommonMethods/CommonMethods";

// Theme colors flow straight into styled-components CSS. A nullish/empty value
// (or the literal strings "null"/"undefined" the API sometimes stores) produces
// `color: null !important`, which stylis rejects and throws on during render,
// crashing the whole page. Fall back to a sane default instead.
const safeColor = (value, fallback) => {
    if (value === null || value === undefined) return fallback;
    const v = String(value).trim();
    if (!v || v.toLowerCase() === 'null' || v.toLowerCase() === 'undefined') return fallback;
    return v;
};
// const sortByYear = (items) => {
//     items.sort((a, b) => {
//         const yearA = a.video_year || a.year;
//         const yearB = b.video_year || b.year;

//         if (!yearA) return 1;
//         if (!yearB) return -1;

//         const dateA = new Date(yearA);
//         const dateB = new Date(yearB);

//         if (isNaN(dateA)) return 1;
//         if (isNaN(dateB)) return -1;

//         return dateB - dateA;
//     });
// };

// const sortYearsInHomePageData = (homePageData) => {
//     return homePageData.map(source => {
//         if (source.data) {
//             sortByYear(source.data);
//         }
//         const categoryKeyMap = {
//             "Videos_based_on_Categories": "category_videos",
//             "Series_based_on_Genres": "category__series",
//             "Live_Stream_based_on_Categories": "category_livestream",
//             "Audio_based_on_Genre": "category__audios"
//         };
//         const categoryKey = categoryKeyMap[source.source];
//         if (categoryKey && source.data) {
//             source.data.forEach(video => {
//                 if (video[categoryKey]) {
//                     sortByYear(video[categoryKey]);
//                 }
//             });
//         }
//         return source;
//     });
// };


const footerReducer = (state = {
    logo: [],
    footerlink: [],
    pages: [], // Add pages array to initial state
    groupedFooterMenu: {}, // Add groupedFooterMenu to initial state
    sociallink: {},
    applink: null,
    companyname: null,
    error: null,
    isLoading: false,
    activeyear: null
}, action) => {
    switch (action.type) {
        case "GET_FOOTER_REQUEST":
            return {
                ...state,
                isLoading: true,
            };
        case "GET_FOOTER_LINKS": return {
            ...state,
            logo: action.payload.Logos,
            footerlink: action.payload.Footer_Menu,
            groupedFooterMenu: action.payload.groupedFooterMenu,
            pages: action.payload.Pages,
            sociallink: action.payload.Social_media_link,
            applink: action.payload.app_settings,
            companyname: action.payload.WebsiteName,
            activeyear: new Date().getFullYear(),
            isLoading: false,
        }
        case "GET_FOOTER_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
};

const homeBannerReducer = (state = { sliderData: null, adminSliderData: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_HOMEBANNER_REQUEST":
            return {
                ...state,
                isLoading: true,
            };
        case "GET_HOMEBANNER": return {
            ...state,
            sliderData: action.payload,
            isLoading: false,
        }
        case "GET_ADMINBANNER": return {
            ...state,
            adminSliderData: action.payload,
            isLoading: false,
        }
        case "GET_HOMEBANNER_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
};

const viewallReducer = (state = { viewAllData: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWALL_REQUEST":
            return {
                ...state,
                isLoading: true,
            };
        case "GET_VIEWALL": return {
            ...state,
            viewAllData: action.payload,
            isLoading: false,
        }
        case "GET_VIEWALL_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}
const settingsReducer = (state = { settings: { access_free: 0, choose_profile_status: 0 }, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_SETTING": return {
            ...state,
            settings: action.payload,
            isLoading: false,
        }
        case "GET_SETTING_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}
const filterReducer = (state = { filter: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_FILTER": return {
            ...state,
            filter: action.payload,
            isLoading: false,
        }
        case "GET_FILTER_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}

const siteThemeReducer = (state = { siteTheme: { translate_checkout: 0 }, currentTheme: 1, error: null, isLoading: false }, action) => {
    switch (action.type) {
        case "GET_SITETHEME_REQUEST":
            return {
                ...state,
                isLoading: true,
            };
        case "GET_SITETHEME": return {
            ...state,
            siteTheme: action.payload,
            currentTheme: Number(action?.payload?.current_theme?.slice(-1)) || 1,
            flimStripe: action?.payload?.movie_stripe || 0,
            isLoading: false,
        }
        case "GET_SITETHEME_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}

const displayTranslateLanguageReducer = (state = { languages: [], error: null, isLoading: false }, action) => {
    switch (action.type) {
        case "GET_DISPLAYTRANSLATELANGUAGE_REQUEST":
            return {
                ...state,
                isLoading: true,
            };
        case "GET_DISPLAYTRANSLATELANGUAGE": return {
            ...state,
            languages: action.payload,
            isLoading: false,
        }
        case "GET_DISPLAYTRANSLATELANGUAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}

const getUserTranslateLanguageReducer = (state = { languageDetailsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_USERTRANSLATELANGUAGEACTION_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case "GET_USERTRANSLATELANGUAGEACTION":
            return {
                ...state,
                languageDetailsData: action.payload,
                isLoading: false
            };
        case "GET_USERTRANSLATELANGUAGEACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};

const videosDetailsReducer = (state = { videoDetailsData: [], videocommentSettings: [], videoButtonResponse: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIDEODETAILSACTION_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: null,
                videoDetailsData: [],
                videocommentSettings: [],
                videoButtonResponse: []
            };
        case "GET_VIDEODETAILSACTION":
            return {
                ...state,
                videoDetailsData: action.payload,
                videocommentSettings: action.videocommentSettings,
                videoButtonResponse: action.videoButtonResponse,
                isLoading: false
            };
        case "GET_VIDEODETAILSACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const userDetailsReducer = (state = { userDetailsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_USERDETAILSACTION_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: null,
                userDetailsData: []
            };
        case "GET_USERDETAILSACTION":
            return {
                ...state,
                userDetailsData: action.payload,
                isLoading: false
            };
        case "GET_USERDETAILSACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const userPermissionReducer = (state = { permissionData: {}, onlyPermission: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_USER_PERMISSION":
            return {
                ...state,
                permissionData: action.payload,
                onlyPermission: action.payload?.onlyPermission || [],
                isLoading: false
            };
        case "GET_USER_PERMISSION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const seriesDetailsReducer = (state = { seriesDetailsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_SERIESDETAILSACTION_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: null,
                seriesDetailsData: [],
            };
        case "GET_SERIESDETAILSACTION":
            return {
                ...state,
                seriesDetailsData: action.payload,
                isLoading: false
            };
        case "GET_SERIESDETAILSACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const episodeDetailsReducer = (state = { episodeDetailsData: [], episodecommentSettings: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_EPISODEDETAILSACTION_REQUEST":
            return {
                ...state,
                isLoading: true
            };
        case "GET_EPISODEDETAILSACTION":
            return {
                ...state,
                episodeDetailsData: action.payload,
                episodecommentSettings: action.episodecommentSettings,
                isLoading: false
            };
        case "GET_EPISODEDETAILSACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const seasonDetailsReducer = (state = { seasonDetailsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_SEASONDETAILSACTION":
            return {
                ...state,
                seasonDetailsData: action.payload,
                isLoading: false
            };
        case "GET_SEASONDETAILSACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const liveDetailsReducer = (state = { rentpayment_setting: [], liveDetailsData: [], livecommentSettings: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_LIVEDETAILSACTION":
            return {
                ...state,
                liveDetailsData: action.payload,
                rentpayment_setting: action.liveResponsePayment_setting,
                livecommentSettings: action.livecommentSettings,
                isLoading: false
            };
        case "GET_LIVEDETAILSACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const linearPlayoutReducer = (state = { linearPlayoutData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_LINEAR_PLAYOUT_ACTION":
            return {
                ...state,
                linearPlayoutData: action.payload,
                isLoading: false
            };
        case "GET_LINEAR_PLAYOUT_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const hlsSignalReducer = (state = { hlsSignalData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_HLS_SIGNAL_ACTION":
            return {
                ...state,
                hlsSignalData: action.payload,
                isLoading: false
            };
        case "GET_HLS_SIGNAL_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const viewerRegisterReducer = (state = { viewerRegisterData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWER_REGISTER_ACTION":
            return {
                ...state,
                viewerRegisterData: action.payload,
                isLoading: false
            };
        case "GET_VIEWER_REGISTER_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
};
const heartBeatReducer = (state = { heartBeatData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_HEARTBEAT_ACTION":
            return {
                ...state,
                heartBeatData: action.payload,
                isLoading: false
            };
        case "GET_HEARTBEAT_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const viewerCountReducer = (state = { viewerCountData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWER_COUNT_ACTION":
            return {
                ...state,
                viewerCountData: action.payload,
                isLoading: false
            };
        case "GET_VIEWER_COUNT_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const viewerUnregisterReducer = (state = { viewerUnregisterData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWER_UNREGISTER_ACTION":
            return {
                ...state,
                viewerUnregisterData: action.payload,
                isLoading: false
            };
        case "GET_VIEWER_UNREGISTER_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const playDetailsReducer = (state = { playDetailsData: [], topArtists: null, settings: null, thumbnailSettings: null, currency: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_PLAYLIST_DETAILS_ACTION":
            return {
                ...state,
                playDetailsData: action?.payload?.audios ? action?.payload?.audios : action?.payload?.data,
                topArtists: action.payload.TopArtist,
                settings: action.payload.setting,
                thumbnailSettings: action.payload.ThumbnailSetting,
                currency: action.payload.currency,
                isLoading: false
            };
        case "GET_PLAYLIST_DETAILS_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const artistDetailsReducer = (state = { artistsDetailsData: [], topArtists: null, artistsAudios: null, settings: null, thumbnailSettings: null, currency: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_ARTISTS_DETAILS_ACTION":
            return {
                ...state,
                artistsDetailsData: action.payload.artist_details,
                topArtists: action.payload.TopArtist,
                artistsAudios: action.payload.artist_audios,
                settings: action.payload.setting,
                thumbnailSettings: action.payload.ThumbnailSetting,
                currency: action.payload.currency,
                isLoading: false
            };
        case "GET_ARTISTS_DETAILS_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const channelDetailsReducer = (state = { channelDetailsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_CHANNEL_DETAILS_ACTION":
            return {
                ...state,
                channelDetailsData: action.payload,
                isLoading: false
            };
        case "GET_CHANNEL_DETAILS_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const contentDetailsReducer = (state = { contentDetailsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_CONTENT_DETAILS_ACTION":
            return {
                ...state,
                contentDetailsData: action.payload,
                isLoading: false
            };
        case "GET_CONTENT_DETAILS_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};


const initialState = {
    homepage: [],
    getSource: [],
    getSourceType: [],
    error: null,
    isLoading: true,
    currentPage: 1,
    totalPages: 1,
    sectionsPerPage: 10,
    totalSections: 0,
    hasMore: true,
    nextPage: null,
};

const allHomePageReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_ALLHOMEPAGE_REQUEST":
            return {
                ...state,
                isLoading: action.meta?.isAppend ? false : true,
                error: null,
            };

        case "GET_ALLHOMEPAGE_ACTION": {
            const isAppend = action.meta?.isAppend;
            const newData = action.payload || [];

            return {
                ...state,
                homepage: isAppend
                    ? [...state.homepage, ...newData]
                    : newData,

                getSource: isAppend
                    ? [
                        ...state.getSource,
                        ...newData.map((item) => (URLGenerater ? URLGenerater(item.homepage_source) : [])),
                    ]
                    : newData.map((item) => (URLGenerater ? URLGenerater(item.homepage_source) : [])),

                getSourceType: isAppend
                    ? [
                        ...state.getSourceType,
                        ...newData.map((item) => (URLGenerater ? URLGenerater(item.SourceTypesNames) : [])),
                    ]
                    : newData.map((item) => (URLGenerater ? URLGenerater(item.SourceTypesNames) : [])),

                currentPage: action.meta?.currentPage || state.currentPage,
                totalPages: action.meta?.totalPages || state.totalPages,
                sectionsPerPage: action.meta?.sectionsPerPage || state.sectionsPerPage,
                totalSections: action.meta?.totalSections || state.totalSections,
                hasMore: action.meta?.hasMore !== undefined ? action.meta.hasMore : state.hasMore,
                nextPage: action.meta?.nextPage || state.nextPage,
                isLoading: false,
            };
        }

        case "GET_ALLHOMEPAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

const specificHomePageReducer = (state = { specificHomepage: [], error: null, isLoading: true, currentPage: 1, hasMore: true }, action) => {
    switch (action.type) {
        case "GET_SPECIFIC_HOMEPAGE_ACTION":
            const isAppendSpecific = action.meta?.isAppend;
            const newSpecificData = action.payload || [];
            return {
                ...state,
                specificHomepage: isAppendSpecific
                    ? [...state.specificHomepage, ...newSpecificData]
                    : newSpecificData,
                currentPage: action.meta?.page || state.currentPage,
                hasMore: action.meta?.hasMore !== undefined ? action.meta.hasMore : state.hasMore,
                isLoading: false,
            };
        case "GET_SPECIFIC_HOMEPAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};
const movieHomePageReducer = (state = { moviePage: [], getSource: [], getSourceType: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "MOVIE_HOMEPAGE":
            return {
                ...state,
                moviePage: action.payload,
                getSource: (action.payload || []).map(item => URLGenerater(item.homepage_source) || []),
                getSourceType: (action.payload || []).map(item => URLGenerater(item.SourceTypesNames) || []),
                isLoading: false,
            };
        case "MOVIE_HOMEPAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};
const showHomePageReducers = (state = { showPage: [], getSource: [], getSourceType: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "SHOW_HOMEPAGE":
            return {
                ...state,
                showPage: action.payload,
                getSource: (action.payload || []).map(item => URLGenerater(item.homepage_source) || []),
                getSourceType: (action.payload || []).map(item => URLGenerater(item.SourceTypesNames) || []),
                isLoading: false,
            };
        case "SHOW_HOMEPAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};
const liveHomePageReducer = (state = { livePage: [], getSource: [], getSourceType: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "LIVE_HOMEPAGE":
            return {
                ...state,
                livePage: action.payload,
                getSource: (action.payload || []).map(item => URLGenerater(item.homepage_source) || []),
                getSourceType: (action.payload || []).map(item => URLGenerater(item.SourceTypesNames) || []),
                isLoading: false,
            };
        case "LIVE_HOMEPAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};

const sportsHierarchyReducer = (state = { sportsHierarchyData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_SPORTS_HIERARCHY":
            return {
                ...state,
                sportsHierarchyData: action.payload,
                isLoading: false,
                error: null
            };
        case "GET_SPORTS_HIERARCHY_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};

const allThumbnailReducer = (state = { thumbnail: [], thumbnailTitle: null, thumbnailAge: null, thumbnailRating: null, thumbnailPublishedYear: null, thumbnailPlayButtonPath: null, thumbnailPlayButton: null, thumbnailTrailer: null, thumbnailReelsVideos: null, thumbnailFreeORCostLabel: null, thumbnailFeatured: null, thumbnailCategory: null, thumbnailDuration: null, thumbnailPublishedOn: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_THUMBNAIL_ACTION":
            return {
                ...state,
                thumbnail: action.payload,
                thumbnailTitle: action.payload[0].title,
                thumbnailAge: action.payload[0].age,
                thumbnailRating: action.payload[0].rating,
                thumbnailPublishedYear: action.payload[0].published_year,
                thumbnailPublishedOn: action.payload[0].published_on,
                thumbnailDuration: action.payload[0].duration,
                thumbnailCategory: action.payload[0].category,
                thumbnailFeatured: action.payload[0].featured,
                thumbnailFreeORCostLabel: action.payload[0].free_or_cost_label,
                thumbnailReelsVideos: action.payload[0].reels_videos,
                thumbnailTrailer: action.payload[0].trailer,
                thumbnailPlayButton: action.payload[0].play_button,
                thumbnailPlayButtonPath: action.payload[0].play_button_path,
                thumbnailDescription: action.payload[0].description,
                isLoading: false
            };
        case "GET_THUMBNAIL_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
}
const headerIndexReducer = (state = {
    headerMenus: null,
    themeMode: {
        body: '#1f222a',
        secondarycolor: '#2d3038',
        text: '#fdfcfc',
        button: '#9b9a9a',
        buttonSecondary: '#9b9a9a',
        buttonText: '#fff',
        currentMode: 'dark',
        logoUrl: 'https://www.classtools.net/profiles/demo-logo.png'
    },
    currentTheme: 1,
    headerSetting: null, error: null, isLoading: true
}, action) => {
    switch (action.type) {
        case "GET_HEADERINDEX_ACTION":
            return {
                ...state,
                headerMenus: action.payload.menu,
                headerindexall: action.payload,
                userDetails: action.payload.user_details,
                currentTheme: action?.payload?.current_theme?.slice(-1),
                themeMode: {
                    body: safeColor(action.payload.theme_mode_details.bg_color, '#1f222a'),
                    text: safeColor(action.payload.theme_mode_details.text_color, '#fdfcfc'),
                    button: safeColor(action.payload.theme_mode_details.button_color, '#9b9a9a'),
                    buttonSecondary: safeColor(action.payload.theme_mode_details.button_secondary_color, '#9b9a9a'),
                    buttonText: safeColor(action.payload.theme_mode_details.button_text_color, '#fff'),
                    buttonTextSecondary: safeColor(action.payload.theme_mode_details.button_text_secondary_color, '#fff'),
                    secondarycolor: safeColor(action.payload.theme_mode_details.bg_secondary_color, '#2d3038'),
                    currentMode: action.payload.theme_mode_details.current_theme_mode,
                    logoUrl: action.payload.theme_mode_details.logo_url,
                    hoverCard: action.payload.theme_mode_details.enable_slider
                },
                headerSetting: action?.payload?.settings,
                isLoading: false
            };
        case "GET_HEADERINDEX_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
}

const profileDetailsReducer = (state = { profileDetails: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_PROFILE_ACTION":
            return {
                ...state,
                profileDetails: action.payload,
                isLoading: false
            };
        case "GET_PROFILE_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
}

const viewAllPageReducer = (state = { viewAllData: null, error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWALLPAGE_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case "GET_VIEWALLPAGE_ACTION":
            console.log('ViewAll Reducer - Received payload:', action.payload);
            return {
                ...state,
                viewAllData: action.payload,
                isLoading: false
            };
        case "GET_VIEWALLPAGE_FAILED":
            console.log('ViewAll Reducer - Error:', action.payload);
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        case "CLEAR_VIEWALLLIST":
            return {
                ...state,
                viewAllData: null,
                isLoading: false
            };
        default:
            return state;
    }
};
const viewAllCategoryPageReducer = (state = { categoryListData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWALLCATEGORYPAGE_REQUEST":
            return {
                ...state,
                isLoading: true,
                categoryListData: [],
                error: null,
            };
        case "GET_VIEWALLCATEGORYPAGE_ACTION":
            return {
                ...state,
                categoryListData: action.payload,
                isLoading: false,
            };
        case "GET_VIEWALLCATEGORYPAGE_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case "CLEAR_VIEWALLCATEGORYLIST":
            return {
                ...state,
                pageListData: [],
                isLoading: false,
            };
        default:
            return state;
    }
};
const languagePageReducer = (state = { languagePageList: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_LANGUAGE_PAGE_LIST_ACTION":
            return {
                ...state,
                languagePageList: action.payload,
                isLoading: false
            };
        case "GET_LANGUAGE_PAGE_LIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const liveCatPageReducer = (state = { liveCatPageList: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_LIVECAT_PAGE_LIST_ACTION":
            return {
                ...state,
                liveCatPageList: action.payload,
                isLoading: false
            };
        case "GET_LIVECAT_PAGE_LIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};

const videoCatPageReducer = (state = { videoCatPageList: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIDEOCAT_PAGE_LIST_ACTION":
            return {
                ...state,
                videoCatPageList: action.payload,
                isLoading: false
            };
        case "GET_VIDEOCAT_PAGE_LIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const seriesCatPageReducer = (state = { seriesCatPageList: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_SERIESCAT_PAGE_LIST_ACTION":
            return {
                ...state,
                seriesCatPageList: action.payload,
                isLoading: false
            };
        case "GET_SERIESCAT_PAGE_LIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const audioCatPageReducer = (state = { audioCatPageList: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_AUDIOCAT_PAGE_LIST_ACTION":
            return {
                ...state,
                audioCatPageList: action.payload,
                isLoading: false
            };
        case "GET_AUDIOCAT_PAGE_LIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};

const viewAllPageIdReducer = (state = { viewallPageId: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWALLPAGEID_REQUEST":
            return {
                ...state,
                isLoading: true,
                viewallPageId: [],
                error: null
            };
        case "GET_VIEWALLPAGEID_ACTION":
            return {
                ...state,
                viewallPageId: action.payload,
                isLoading: false
            };
        case "GET_VIEWALLPAGEID_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const viewAllPageCatIdReducer = (state = { viewallPageCatId: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_VIEWALLPAGECATID_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: null,
                viewallPageCatId: []
            };
        case "GET_VIEWALLPAGECATID_ACTION":
            return {
                ...state,
                viewallPageCatId: action.payload,
                isLoading: false
            };
        case "GET_VIEWALLPAGECATID_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const getwatchLaterListReducer = (state = { getwatchlaterData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_WATCHLATERLIST_ACTION":
            return {
                ...state,
                getwatchlaterData: action.payload,
                isLoading: false
            };
        case "GET_WATCHLATERLIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const getWishListReducer = (state = { getWishListData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_WISHLIST_ACTION":
            return {
                ...state,
                getWishListData: action.payload,
                isLoading: false
            };
        case "GET_WISHLIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const getMyListReducer = (state = { getmylistData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_MYLIST_ACTION":
            return {
                ...state,
                getmylistData: action.payload,
                isLoading: false
            };
        case "GET_MYLIST_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default: return state;
    }
};
const getRecentViewsReducer = (state = { getrecentviewsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_RECENTVIEWS_ACTION":
            return {
                ...state,
                getrecentviewsData: action.payload,
                isLoading: false
            };
        case "GET_RECENTVIEWS_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default: return state;
    }
};
const getPlayerSettingsReducer = (state = { getPlayerSettingsData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_PLAYER_SETTINGS_ACTION":
            return {
                ...state,
                getPlayerSettingsData: action.payload,
                isLoading: false
            };
        case "GET_PLAYER_SETTINGS_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const getMusicSettingsReducer = (state = { getMusicData: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_MUSIC_ACTION":
            return {
                ...state,
                getMusicData: action.payload,
                isLoading: false
            };
        case "GET_MUSIC_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};
const signUpSettingReducer = (state = {
    fieldRestrict: {
        "username": 1,
        "email": 1,
        "mobile": 1,
        "avatar": 1,
        "password": 1,
        "password_confirm": 1,
        "dob": 1,
        "country": 1,
        "state": 1,
        "city": 1,
        "support_username": 1,
    }, error: null, isLoading: true
}, action) => {
    switch (action.type) {
        case "SIGNUP-SETTINGS": return {
            ...state,
            fieldRestrict: action.payload,
            isLoading: false,
        }
        case "SIGNUP-SETTINGS_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}
const labelReducer = (state = { label: [], error: null, isLoading: true }, action) => {
    switch (action.type) {
        case "GET_LABEL": return {
            ...state,
            label: action.payload,
            isLoading: false,
        }
        case "GET_LABEL_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        default:
            return state;
    }
}
const commentsReducer = (state = { comments: [], error: null, commentsLoading: true }, action) => {
    switch (action.type) {
        case "GET_COMMENT_ACTION": return {
            ...state,
            comments: action.payload,
            commentsLoading: false,
        }
        case "GET_COMMENT_FAILED":
            return {
                ...state,
                error: action.payload,
                commentsLoading: false,
            };
        default:
            return state;
    }
}
export { userPermissionReducer, userDetailsReducer, labelReducer, signUpSettingReducer, liveHomePageReducer, showHomePageReducers, movieHomePageReducer, footerReducer, homeBannerReducer, viewallReducer, settingsReducer, filterReducer, siteThemeReducer, displayTranslateLanguageReducer, getUserTranslateLanguageReducer, videosDetailsReducer, seriesDetailsReducer, liveDetailsReducer, linearPlayoutReducer, hlsSignalReducer, viewerRegisterReducer, heartBeatReducer, viewerCountReducer, viewerUnregisterReducer, allHomePageReducer, specificHomePageReducer, artistDetailsReducer, channelDetailsReducer, contentDetailsReducer, allThumbnailReducer, headerIndexReducer, profileDetailsReducer, playDetailsReducer, viewAllPageReducer, languagePageReducer, viewAllPageIdReducer, liveCatPageReducer, viewAllPageCatIdReducer, videoCatPageReducer, seriesCatPageReducer, audioCatPageReducer, episodeDetailsReducer, seasonDetailsReducer, getwatchLaterListReducer, getWishListReducer, getMyListReducer, getRecentViewsReducer, getPlayerSettingsReducer, getMusicSettingsReducer, commentsReducer, viewAllCategoryPageReducer, sportsHierarchyReducer }
